var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pdf"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29237",
    "data-name": "Rectangle 29237",
    width: 24,
    height: 24,
    transform: "translate(929 433)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_655",
    "data-name": "Mask Group 655",
    transform: "translate(-929 -433)",
    clipPath: "url(#pdf)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_80_",
    "data-name": "svgexport-6 (80)",
    transform: "translate(932.026 433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11509",
    "data-name": "Group 11509",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_15_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11548",
    "data-name": "Path 11548",
    d: "M10.94,0h8.024l6.8,7.088V20.876A3.121,3.121,0,0,1,22.646,24H10.94a3.122,3.122,0,0,1-3.124-3.124V3.124A3.122,3.122,0,0,1,10.94,0Z",
    transform: "translate(-7.816 0)",
    fill: "#e5252a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11508",
    "data-name": "Group 11508",
    transform: "translate(3.472 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11549",
    "data-name": "Path 11549",
    d: "M36.6,0V7.034h6.807Z",
    transform: "translate(-28.93)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11550",
    "data-name": "Path 11550",
    d: "M16.786,39.319V34.935h1.865a1.546,1.546,0,0,1,1.1.384,1.463,1.463,0,0,1,0,2.039,1.546,1.546,0,0,1-1.1.384h-.744v1.577Zm1.121-2.531h.618a.553.553,0,0,0,.39-.12.463.463,0,0,0,0-.66.552.552,0,0,0-.39-.12h-.618Zm2.723,2.531V34.935h1.553a2.712,2.712,0,0,1,.864.132,2.321,2.321,0,0,1,.732.39,1.722,1.722,0,0,1,.516.684,2.71,2.71,0,0,1,0,1.973,1.722,1.722,0,0,1-.516.684,2.322,2.322,0,0,1-.732.39,2.713,2.713,0,0,1-.864.132Zm1.1-.954h.324a1.8,1.8,0,0,0,.486-.06,1.456,1.456,0,0,0,.414-.2.889.889,0,0,0,.3-.384,1.7,1.7,0,0,0,0-1.193.889.889,0,0,0-.3-.384,1.456,1.456,0,0,0-.414-.2,1.8,1.8,0,0,0-.486-.06h-.324Zm3.316.954V34.935h3.118v.954h-2v.7h1.6v.948h-1.6v1.781Z",
    transform: "translate(-16.786 -21.412)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.552cbbc2b6930888bd3780d7c62d2c44.svg";
export { ForwardRef as ReactComponent };